const config = {
    development: {
        API_URI: process.env.REACT_APP_API_URI || 'http://localhost:4000',
        //API_URI: process.env.REACT_APP_API_URI || 'https://kiosk-pluracore-60922b42b03b.herokuapp.com',
    },
    production: {
        API_URI: process.env.REACT_APP_API_URI || 'https://kiosk-pluracore-60922b42b03b.herokuapp.com',
    }
};

export default config[process.env.NODE_ENV || 'development'];
